import actionTypes from "../../actionTypes"

export const setPaymentStatus = data => {
    return {
        type: actionTypes.payment,
        payload: data
    }
}
export const setPaymentId = data => {
    return {
        type: actionTypes.paymentId,
        payload: data
    }
}
export const setActivePlan = data => {
    return {
        type: actionTypes.setActivePlan,
        payload: data
    }
}
export const setFeatures = data => {
    return {
        type: actionTypes.setFeatures,
        payload: data
    }
}
export const setPaymentInterval = data => {
    return {
        type: actionTypes.setPaymentInterval,
        payload: data
    }
}
export const setFeedback = data => {
    return {
        type: actionTypes.setFeedback,
        payload: data
    }
}
export const addShopName = data => {
    return {
        type: actionTypes.addShopName,
        payload: data
    }
}
export const setRemainingTrial = data => {
    return {
        type: actionTypes.setRemainingTrial,
        payload: data ? data : 0
    }
}
export const saveCurrency = data => {
    return {
        type: actionTypes.saveCurrency,
        payload: data
    }
}
export const ShowWarning = data => {
    return {
        type: actionTypes.ShowWarning,
        payload: data
    }
}
export const ShowMessage = data => {
    return {
        type: actionTypes.ShowMessage,
        payload: data
    }
}
export const saveShopId = data => {
    return {
        type: actionTypes.saveShopId,
        payload: data
    }
}
export const setStore = data => {
    return {
        type: actionTypes.setStore,
        payload: data
    }
}
// export const saveFreeShippingRule = data => {
//     return {
//         type: actionTypes.saveFreeShippingRule,
//         payload: data
//     }
// }
export const saveCountry = data => {
    return {
        type: actionTypes.saveCountry,
        payload: data
    }
}
export const saveStatesList = data => {
    return {
        type: actionTypes.saveStatesList,
        payload: data
    }
}
export const saveCountries = data => {
    return {
        type: actionTypes.saveCountries,
        payload: data
    }
}

export const setTitle = title => {
    return {
        type: actionTypes.setTitle,
        payload: title
    }
}
export const setToast = ({ active = false, content = '', error = false } = {}) => {
    return {
        type: actionTypes.setToast,
        payload: { active, content, error }
    }
}
export const setHost = data => {
    return {
        type: actionTypes.setHost,
        payload: data
    }
}
export const setLocations = data => {
    return {
        type: actionTypes.setLocations,
        payload: data
    }
}